import { Box, CircularProgress, LinearProgress, Typography } from '@mui/material'

/**
 * Keeps upload history table mounted while refreshing so only row data updates.
 * Full-page spinner only on initial load when there is no data yet.
 */
const UploadHistoryTableWrapper = ({
  loading,
  isEmpty,
  emptyState = null,
  emptyMessage = 'No upload logs found',
  children,
}) => {
  if (loading && isEmpty) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
        <CircularProgress size={32} sx={{ color: '#e90000' }} />
      </Box>
    )
  }

  if (!loading && isEmpty) {
    if (emptyState) {
      return emptyState
    }
    return (
      <Typography sx={{ color: '#999', textAlign: 'center', py: 3 }}>
        {emptyMessage}
      </Typography>
    )
  }

  return (
    <Box sx={{ position: 'relative' }}>
      {loading && (
        <LinearProgress
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 2,
            borderRadius: 1,
          }}
        />
      )}
      <Box
        sx={{
          opacity: loading ? 0.55 : 1,
          transition: 'opacity 0.2s ease',
          pointerEvents: loading ? 'none' : 'auto',
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default UploadHistoryTableWrapper
